import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import { encryptAES, decryptAES } from "../cryptoUtils";
import { getToken, setToken } from '../context/tokenManager';
// this is for the update user id
// const BASE_URL = 'https://api-uat.iciciprulife.com/v1/biu-instatrack';
const BASE_URL = 'https://api.iciciprulife.com/v1/biu-instatrack';
// ✅ Custom axios instance
const apiClient3 = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: false,
});

// ✅ REQUEST INTERCEPTOR
apiClient3.interceptors.request.use((config) => {
  // 1. Get token securely from Memory
  const token = getToken();
  
  // 2. Attach token if it exists and we haven't manually provided one
  if (token && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`; 
  }

  // 3. Encrypt payload
  if (config.method === 'post' && config.data && !config.data.encryptedRequest) {
    const plainString = JSON.stringify(config.data);
    config.data = { encryptedRequest: encryptAES(plainString) };
  }
  return config;
}, (error) => Promise.reject(error));

// ✅ RESPONSE INTERCEPTOR (Kept mostly same, just added safety checks)

apiClient3.interceptors.response.use(
  (response) => {
    const newToken = response.data?.['jwt-token'] || response.data?.Token || response.headers?.authorization;
    if (newToken) {
      setToken(newToken); // Saved in memory, nowhere else!
      console.log(newToken)
    }
    
    if (response.data?.encryptedResponse) {
      try {
        const decryptedString = decryptAES(response.data.encryptedResponse);
        response.data = JSON.parse(decryptedString);
      } catch (err) {
        console.error('Response decrypt error:', err);
      }
    }
    // 2. Check for NEW token and save securely to MEMORY
    console.log("Response.data: ", response.data)
    
    return response;
  },
  (error) => Promise.reject(error)
);

export const updateUserIdSSO = async (combinedKey, initialToken) => {
  const config = initialToken ? { headers: { Authorization: `Bearer ${initialToken}` } } : {};
  
  const res = await apiClient3.post('/update_user_id', { key: combinedKey }, config);
  console.log("Response of Calling UpdateUserId: ", res)
  res.data.session_id = crypto.randomUUID();
  return res.data; 
};

export default apiClient3;